<template>
  <div id="contenedor-principal-altaFirmas" style="position:relative;">
    <div id="contenedor-encabezados-altaFirmas" class="text-left">
      <h1>Firmas</h1>
      <h3>Alta de firmas</h3>      
    </div>
    <div id="contenedor-principal-altaFirmas" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      <div  id="contenedor-filtros-altaFirmas" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">      
        <div >
          <div class="area">
            <FiltroAltaFirmas 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :elementosAConservar ="elementosAConservar"
                :key="'filtro'+contrenderfiltros"
                :AccionesMostrar="accionesMostrar"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="guardarAltaFirmasAPI"
                :area="obtenerAreaDeUsuario"
                :tituloDeBusqueda="'Ingrese los datos del procesado'"              
                :ref="'campoAltaFirmas'">
            </FiltroAltaFirmas>
          </div>
        </div>             
      </div>
      </transition>

      
    </div>
    
  </div>
</template>

<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'

  import FiltroAltaFirmas from '@/components/SIVAC/Comun/FiltroAltaFirmas.vue'

  export default{
    data(){
      return{
        enumeraciones,
        accionesMostrar:{
          pagos: true,
          firma: false,
          guardar: true,
          buscar: false
        },
        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },
          { catalogoId: enumeraciones.catalogos.Delitos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Delito' },
          { catalogoId: enumeraciones.catalogos.Entidades, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Entidad' },
          { catalogoId: enumeraciones.catalogos.Municipios, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Municipio' },
          { catalogoId: enumeraciones.catalogos.Temporalidades, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Temporalidad' }
         
        ],

        elementosAOmitir: {
          //materias: [5,10] //áreas de Majat
        },

        elementosAConservar:{

          partidosJudiciales: [1],  
           tiposDocumento: [1,5],
           areas: [12,95],
           materias: [6],
           entidades: [1],


        },

        contrenderfiltros: 0,

        actualizoarea: false,

      }

    },

    computed:{

      // elementosAConservar : function()
      // {
      //   let ep = {
      //      partidosJudiciales: [1],  
      //      tiposDocumento: [1,5],
      //      areas: [12,95],
      //      materias: [6],
      //      entidades: [1],
      //   }
      //   return ep;
      // },


      /**
       * Funcion encargadas de obtener area del usuario de store.
       */
      obtenerAreaDeUsuario() {

          
        return this.$store.getters.Get_AreaDelUsuario;




      }



    },


    watch: {
        '$store.getters.Get_AreaDelUsuario': function() {
            
            //console.log("entro en watch", this.$store.getters.Get_AreaDelUsuario);


            if(!this.actualizoarea){

              if((this.$store.getters.Get_AreaDelUsuario==null || this.$store.getters.Get_AreaDelUsuario==undefined) || (this.$store.getters.Get_AreaDelUsuario.AreaId==112) ||  (this.$store.getters.Get_AreaDelUsuario.AreaId==1)){


               // this.elementosAConservar= null;
                
                this.actualizoarea= true;

                

              }

              this.contrenderfiltros++;




            }
        }
    },


   
    components:{
      FiltroAltaFirmas
    },
    methods:{
      validarDatosAltaImputado: function(datos)
      { 
        // console.log(datos);
        const { Expediente, Persona, Procesado, Firma, DelitosProcesados } = datos;



        if(Expediente.PartidoJudicialId == null || Expediente.PartidoJudicialId == -1){
          comun.mensajeDeAlerta("Favor de indicar el partido judicial.", null, null);
          return false;
        }

        if(Expediente.AreaId == null || Expediente.AreaId == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el juzgado.", null, null);
          return false;
        }

        if(Expediente.MateriaId == null || Expediente.MateriaId == -1) { 
          comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
          return false;
        }

        if(Expediente.TipoDocumentoId == null || Expediente.TipoDocumentoId == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el tipo de documento.", null, null);
          return false;
        }


        if(Expediente.Consecutivo == null || Expediente.Consecutivo.length < 9) { 
          comun.mensajeDeAlerta("Favor de indicar el consecutivo completo.", null, null);
          return false;
        }


        if(Persona.Nombre == null || Persona.Nombre == undefined) { 
          comun.mensajeDeAlerta("Favor de indicar el nombre.", null, null);
          return false;
        }

        if((Persona.ApellidoPaterno == null || Persona.ApellidoPaterno == undefined) && (Persona.ApellidoMaterno == null || Persona.ApellidoMaterno == undefined)) {
          comun.mensajeDeAlerta("Favor de indicar al menos un apellido.", null, null);
          return false;
        }


        if(Persona.Direccion == null || Persona.Direccion == undefined) { 
          comun.mensajeDeAlerta("Favor de indicar la direccion.", null, null);
          return false;
        }

        if(Persona.Municipios_010DBPJ == null || Persona.Municipios_010DBPJ == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el municipio.", null, null);
          return false;
        }

        if(Persona.EntidadesFederativas_011DBPJ == null || Persona.EntidadesFederativas_011DBPJ == -1) { 
          comun.mensajeDeAlerta("Favor de indicar la entidad.", null, null);
          return false;
        }


        if(Procesado.TipoTemporalidadId == null || Procesado.TipoTemporalidadId == -1) { 
          comun.mensajeDeAlerta("Favor de indicar la temporalidad.", null, null);
          return false;
        }


        if(Procesado.DelitosProcesados ==null || Procesado.DelitosProcesados == -1) { 
          comun.mensajeDeAlerta("Favor de indicar el delito.", null, null);
          return false;
        }


        return true;





       },
      guardarAltaFirmasAPI:function() 
      { 

        

        const parametros = 
        {    
                    
         
          Expediente:{
           
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.partidoJudicialId : null,
            AreaId: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_Area.areaId) ? this.$refs['campoAltaFirmas'].parametros_Area.areaId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_Materia.materiaId) ? this.$refs['campoAltaFirmas'].parametros_Materia.materiaId : null,
            TipoDocumentoId: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['campoAltaFirmas'].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].consecutivo) ? this.$refs['campoAltaFirmas'].consecutivo : null,
            NumeroRomano: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].numeroRomano) ? this.$refs['campoAltaFirmas'].numeroRomano : null 
          },
         
          Persona:{
            Nombre:  this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].nombre) ? this.$refs['campoAltaFirmas'].nombre : null,
            ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].apellido_paterno) ? this.$refs['campoAltaFirmas'].apellido_paterno : null,
            ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].apellido_materno) ? this.$refs['campoAltaFirmas'].apellido_materno : null,
            Direccion: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].direccion) ? this.$refs['campoAltaFirmas'].direccion : null,
            Municipios_010DBPJ: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_Municipio.municipioId) ? this.$refs['campoAltaFirmas'].parametros_Municipio.municipioId : null,
            EntidadesFederativas_011DBPJ: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId) ? this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId : null,
          },

          Procesado:{

           
            TipoTemporalidadId: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].parametros_Temporalidad.temporalidadId) ? this.$refs['campoAltaFirmas'].parametros_Temporalidad.temporalidadId : null,

            ClaveDelProcesado_Anterior: this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].clave_del_procesado_anterior) ? this.$refs['campoAltaFirmas'].clave_del_procesado_anterior : null,


             DelitosProcesados:this.campoRequeridoEsValido(this.$refs['campoAltaFirmas'].opcionesInputDelito.seleccionadas) ? 
              this.$refs['campoAltaFirmas'].opcionesInputDelito.seleccionadas.map(s => {
              s.DelitoId_008DBPJ = s.llave
              return s
               }) 
              : null 

            

          },

          

          
        }

        
        
        if(this.validarDatosAltaImputado(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.administracion.firmas.AltaFirmas, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesado
              this.Procesado = respuesta.data.Procesado;
              //this.limpiarTablaResultados();
              this.limpiarFiltros();
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },

      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },


       /** //  // 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.firmas = null;
      },



            /**
       * Método encargado de limpiar los filtros de los combos del formulario.
       * Cambia el valor original de lo ingresado
       */
      limpiarFiltros: function(){


        if(this.area != undefined && this.area != null && (this.area.AreaId!=1 && this.area.AreaId!=112))
        {


        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
        this.$refs['campoAltaFirmas'].parametros_Area.parametros.AreaId = this.area.AreaId;
        this.$refs['campoAltaFirmas'].parametros_Materia.parametros.AreaId = this.area.AreaId;
        this.$refs['campoAltaFirmas'].parametros_Area.parametros.conInactivos = true;


        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.PartidoJudicialId = -1;
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.AreaId = -1;
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.MateriaId = -1;
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.key +=1;
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.tipoDocumentoId= -1;

        this.$refs['campoAltaFirmas'].parametros_Materia.parametros.elementosAConservar = [6];


        this.$refs['campoAltaFirmas'].baseDeDatosId = null;        

        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.tipoDocumentoId = -1;   //1          
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.key += 1;   

        this.$refs['campoAltaFirmas'].parametros_Delito.delitoId = -1;
        this.$refs['campoAltaFirmas'].parametros_Delito.key += 1; 

       
        this.$refs['campoAltaFirmas'].parametros_Municipio.municipioId = -1; // para volver a seleccionar un municipio al hacer un alta
        this.$refs['campoAltaFirmas'].parametros_Municipio.key += 1;

        
        this.$refs['campoAltaFirmas'].parametros_Entidades.key +=-1;

        this.$refs['campoAltaFirmas'].parametros_Temporalidad.temporalidadId = -1;
        this.$refs['campoAltaFirmas'].parametros_Temporalidad.key +=-1;

        this.$refs['campoAltaFirmas'].obtenerListaDeDelitos();


        this.$refs['campoAltaFirmas'].numeroExtra = null;
        this.$refs['campoAltaFirmas'].$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.$refs['campoAltaFirmas'].consecutivo = null;             
        this.$refs['campoAltaFirmas'].numeroCarpeta = null;
        this.$refs['campoAltaFirmas'].numeroRomano = null; 
       
        this.$refs['campoAltaFirmas'].nombre = null;
        this.$refs['campoAltaFirmas'].apellido_paterno = null;
        this.$refs['campoAltaFirmas'].apellido_materno = null; 
        this.$refs['campoAltaFirmas'].direccion = null;
        this.$refs['campoAltaFirmas'].clave_del_procesado_anterior = null;


        // this.$refs['campoAltaFirmas'].cambioDeEntidad(parseInt(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId));



        if(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId==1){


          this.$refs['campoAltaFirmas'].cambioDeMunicipio(parseInt(this.$refs['campoAltaFirmas'].parametros_Municipio.municipioId));


        }

        else {

          this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId = 1; 
          // para volver a cargar por defecto aguascalientes cuando en el alta se selecciono otro estado diferente

          this.$refs['campoAltaFirmas'].cambioDeEntidad(parseInt(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId));



        }

        }

        else{


        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.partidoJudicialId = 1;
        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.parametros.PartidoJudicialId = -1;
        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.parametros.AreaId = -1;
        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.parametros.MateriaId = -1;        
        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.key += 1;      

        this.$refs['campoAltaFirmas'].parametros_Materia.materiaId = -1; // 6


        this.$refs['campoAltaFirmas'].parametros_Materia.parametros.PartidoJudicialId = -1;
        this.$refs['campoAltaFirmas'].parametros_Materia.parametros.AreaId = -1;
        this.$refs['campoAltaFirmas'].parametros_Materia.parametros.MateriaId = -1;       
        this.$refs['campoAltaFirmas'].parametros_Materia.key += 1;

        this.$refs['campoAltaFirmas'].parametros_Area.areaId = -1; // 12


        this.$refs['campoAltaFirmas'].parametros_Area.parametros.PartidoJudicialId = -1;
        this.$refs['campoAltaFirmas'].parametros_Area.parametros.AreaId = -1;
        this.$refs['campoAltaFirmas'].parametros_Area.parametros.MateriaId = -1;        
        this.$refs['campoAltaFirmas'].parametros_Area.key += 1;

        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.PartidoJudicialId = -1;
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.AreaId = -1;
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.MateriaId = -1;   

       

        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.parametros.elementosAConservar = [1,5];
        this.$refs['campoAltaFirmas'].parametros_Area.parametros.elementosAConservar = [12,95];
        this.$refs['campoAltaFirmas'].parametros_PartidoJudicial.parametros.elementosAConservar = [1];
        this.$refs['campoAltaFirmas'].parametros_Materia.parametros.elementosAConservar = [6];




        this.$refs['campoAltaFirmas'].baseDeDatosId = null;        

        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.tipoDocumentoId = -1;   //1          
        this.$refs['campoAltaFirmas'].parametros_TipoDocumento.key += 1;   

        this.$refs['campoAltaFirmas'].parametros_Delito.delitoId = -1;
        this.$refs['campoAltaFirmas'].parametros_Delito.key += 1; 

       
        this.$refs['campoAltaFirmas'].parametros_Municipio.municipioId = -1; // para volver a seleccionar un municipio al hacer un alta
        this.$refs['campoAltaFirmas'].parametros_Municipio.key += 1;

        
        this.$refs['campoAltaFirmas'].parametros_Entidades.key +=-1;

        this.$refs['campoAltaFirmas'].parametros_Temporalidad.temporalidadId = -1;
        this.$refs['campoAltaFirmas'].parametros_Temporalidad.key +=-1;

        this.$refs['campoAltaFirmas'].obtenerListaDeDelitos();


        this.$refs['campoAltaFirmas'].numeroExtra = null;
        this.$refs['campoAltaFirmas'].$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.$refs['campoAltaFirmas'].consecutivo = null;             
        this.$refs['campoAltaFirmas'].numeroCarpeta = null;
        this.$refs['campoAltaFirmas'].numeroRomano = null; 
       
        this.$refs['campoAltaFirmas'].nombre = null;
        this.$refs['campoAltaFirmas'].apellido_paterno = null;
        this.$refs['campoAltaFirmas'].apellido_materno = null; 
        this.$refs['campoAltaFirmas'].direccion = null;
        this.$refs['campoAltaFirmas'].clave_del_procesado_anterior = null;


        // this.$refs['campoAltaFirmas'].cambioDeEntidad(parseInt(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId));



        if(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId==1){


          this.$refs['campoAltaFirmas'].cambioDeMunicipio(parseInt(this.$refs['campoAltaFirmas'].parametros_Municipio.municipioId));


        }

        else {

          this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId = 1; 
          // para volver a cargar por defecto aguascalientes cuando en el alta se selecciono otro estado diferente

          this.$refs['campoAltaFirmas'].cambioDeEntidad(parseInt(this.$refs['campoAltaFirmas'].parametros_Entidades.entidadId));



        }



        }
       
        


        
       
         
      },





    }
  }

</script>


<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style>

.newSectionFilters .btn-light {
    background-color: green;
    border: 1px solid #4F4949;
    color: #42505c;
    font-size: 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Administracion/AltaFirmas.vue